/* Auto-built from nemiMatrix.json — every function of the contract is covered. */
import { fmt } from "../shared/format";

export const readFunctions = [
  {
    name: "advanceExemptionExpiry",
    title: "Advance Exemption Expiry",
    description: "Read `advanceExemptionExpiry` from the contract",
    icon: "💳",
    category: "Other",
    inputs: [
      { name: "arg0", type: "address", label: "Address", placeholder: "0x…", required: true },
    ],
    formatOutput: (v) => fmt.time(v),
  },
  {
    name: "advanceExemptionPeriod",
    title: "Advance Exemption Period",
    description: "Read `advanceExemptionPeriod` from the contract",
    icon: "💳",
    category: "Timing",
    inputs: [],
    formatOutput: (v) => fmt.duration(v),
  },
  {
    name: "advancePaymentAmount",
    title: "Advance Payment Amount",
    description: "Read `advancePaymentAmount` from the contract",
    icon: "💳",
    category: "Economics",
    inputs: [],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "burnIncomePercent",
    title: "Burn Income Percent",
    description: "Read `burnIncomePercent` from the contract",
    icon: "🔥",
    category: "Income & Percentages",
    inputs: [],
    formatOutput: (v) => fmt.percent(v),
  },
  {
    name: "buyingIncomePercent",
    title: "Buying Income Percent",
    description: "Read `buyingIncomePercent` from the contract",
    icon: "🛒",
    category: "Income & Percentages",
    inputs: [],
    formatOutput: (v) => fmt.percent(v),
  },
  {
    name: "creatorReceiver",
    title: "Creator Receiver",
    description: "Read `creatorReceiver` from the contract",
    icon: "🔹",
    category: "Receivers & Wallets",
    inputs: [],
  },
  {
    name: "directIncomePercent",
    title: "Direct Income Percent",
    description: "Read `directIncomePercent` from the contract",
    icon: "💰",
    category: "Income & Percentages",
    inputs: [],
    formatOutput: (v) => fmt.percent(v),
  },
  {
    name: "findFreeReferrer",
    title: "Find Free Referrer",
    description: "Find the first upline with a free position under the given user.",
    icon: "🌳",
    category: "User Info",
    inputs: [
      { name: "_user", type: "address", label: "User", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "getDirectReferrer",
    title: "Get Direct Referrer",
    description: "Read `getDirectReferrer` from the contract",
    icon: "🌳",
    category: "User Info",
    inputs: [
      { name: "account", type: "address", label: "Account", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "getFundEligible",
    title: "Get Fund Eligible",
    description: "Read `getFundEligible` from the contract",
    icon: "🔹",
    category: "User Info",
    inputs: [
      { name: "account", type: "address", label: "Account", placeholder: "0x…", required: true },
    ],
    formatOutput: (v) => fmt.bool(v),
  },
  {
    name: "getIncomeAmount",
    title: "Get Income Amount",
    description: "Read `getIncomeAmount` from the contract",
    icon: "💰",
    category: "Rewards",
    inputs: [
      { name: "level", type: "uint8", label: "Level", placeholder: "Enter level", required: true },
      { name: "income", type: "uint8", label: "Income", placeholder: "Enter income", required: true },
    ],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "getLevelTreeDetails",
    title: "Get Level Tree Details",
    description: "Read `getLevelTreeDetails` from the contract",
    icon: "🌳",
    category: "User Info",
    inputs: [
      { name: "userAccount", type: "address", label: "User Account", placeholder: "0x…", required: true },
    ],
    formatOutput: (v) => [
      `First Upline: ${v.firstUpline ?? v[0]}`,
      `Downlines: ${v.downlines ?? v[1]}`,
      `Is Downline Reached: ${fmt.bool(v.isDownlineReached ?? v[2])}`,
    ].join("\n"),
  },
  {
    name: "getPrincipleBurnAmount",
    title: "Get Principle Burn Amount",
    description: "Read `getPrincipleBurnAmount` from the contract",
    icon: "🔥",
    category: "User Info",
    inputs: [
      { name: "account", type: "address", label: "Account", placeholder: "0x…", required: true },
      { name: "principleAmount", type: "uint256", label: "Principle Amount", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "getSaleDirectCondition",
    title: "Get Sale Direct Condition",
    description: "Read `getSaleDirectCondition` from the contract",
    icon: "🛒",
    category: "User Info",
    inputs: [
      { name: "treeLine", type: "uint256", label: "Tree Line", placeholder: "Enter tree line", required: true },
    ],
  },
  {
    name: "getSubDirectCondition",
    title: "Get Sub Direct Condition",
    description: "Read `getSubDirectCondition` from the contract",
    icon: "🔹",
    category: "User Info",
    inputs: [
      { name: "treeLine", type: "uint256", label: "Tree Line", placeholder: "Enter tree line", required: true },
    ],
  },
  {
    name: "getTeamSize",
    title: "Get Team Size",
    description: "Read `getTeamSize` from the contract",
    icon: "🌳",
    category: "User Info",
    inputs: [
      { name: "account", type: "address", label: "Account", placeholder: "0x…", required: true },
      { name: "requireSize", type: "uint256", label: "Require Size", placeholder: "Enter require size", required: true },
    ],
  },
  {
    name: "getTotalRewardChunk",
    title: "Get Total Reward Chunk",
    description: "Read `getTotalRewardChunk` from the contract",
    icon: "💰",
    category: "User Info",
    inputs: [
      { name: "account", type: "address", label: "Account", placeholder: "0x…", required: true },
      { name: "amount", type: "uint256", label: "Amount", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "getUserDownline",
    title: "Get User Downline",
    description: "Read `getUserDownline` from the contract",
    icon: "🌳",
    category: "User Info",
    inputs: [
      { name: "account", type: "address", label: "Account", placeholder: "0x…", required: true },
    ],
    formatOutput: (v) => fmt.list(v),
  },
  {
    name: "getUserHoldingLimit",
    title: "Get User Holding Limit",
    description: "How many NFTs/trades the account may hold right now (a count, not an amount).",
    icon: "👤",
    category: "User Info",
    inputs: [
      { name: "account", type: "address", label: "Account", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "getUserLevelStatus",
    title: "Get User Level Status",
    description: "Read `getUserLevelStatus` from the contract",
    icon: "👤",
    category: "User Info",
    inputs: [
      { name: "account", type: "address", label: "Account", placeholder: "0x…", required: true },
      { name: "level", type: "uint8", label: "Level", placeholder: "Enter level", required: true },
    ],
    formatOutput: (v) => fmt.bool(v),
  },
  {
    name: "getUserPlanLimt",
    title: "Get User Plan Limit",
    description: "Read `getUserPlanLimt` from the contract",
    icon: "👤",
    category: "User Info",
    inputs: [
      { name: "account", type: "address", label: "Account", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "globalNftLimitPeriod",
    title: "Global NFT Limit Period",
    description: "Read `globalNftLimitPeriod` from the contract",
    icon: "⏱️",
    category: "Economics",
    inputs: [],
    formatOutput: (v) => fmt.duration(v),
  },
  {
    name: "holdingMax",
    title: "Holding Max",
    description: "Maximum number of holdings allowed (a count).",
    icon: "📈",
    category: "Economics",
    inputs: [],
  },
  {
    name: "idToAddress",
    title: "ID To Address",
    description: "Read `idToAddress` from the contract",
    icon: "🔹",
    category: "User Info",
    inputs: [
      { name: "arg0", type: "uint256", label: "Index", placeholder: "Enter value", required: true },
    ],
  },
  {
    name: "isAdvanceExempt",
    title: "Is Advance Exempt",
    description: "Read `isAdvanceExempt` from the contract",
    icon: "💳",
    category: "User Info",
    inputs: [
      { name: "account", type: "address", label: "Account", placeholder: "0x…", required: true },
    ],
    formatOutput: (v) => fmt.bool(v),
  },
  {
    name: "isBotStatus",
    title: "Is Bot Status",
    description: "Read `isBotStatus` from the contract",
    icon: "🤖",
    category: "Bots",
    inputs: [
      { name: "arg0", type: "address", label: "Address", placeholder: "0x…", required: true },
    ],
    formatOutput: (v) => fmt.bool(v),
  },
  {
    name: "isUserExists",
    title: "Is User Exists",
    description: "Check whether the address has joined the matrix.",
    icon: "👤",
    category: "User Info",
    inputs: [
      { name: "account", type: "address", label: "Account", placeholder: "0x…", required: true },
    ],
    formatOutput: (v) => fmt.bool(v),
  },
  {
    name: "isUserSubscribed",
    title: "Is User Subscribed",
    description: "Read `isUserSubscribed` from the contract",
    icon: "🚀",
    category: "User Info",
    inputs: [
      { name: "account", type: "address", label: "Account", placeholder: "0x…", required: true },
    ],
    formatOutput: (v) => fmt.bool(v),
  },
  {
    name: "lastUserAddress",
    title: "Last User Address",
    description: "Read `lastUserAddress` from the contract",
    icon: "👤",
    category: "User Info",
    inputs: [],
  },
  {
    name: "levelIncomePercent",
    title: "Level Income Percent",
    description: "Read `levelIncomePercent` from the contract",
    icon: "💰",
    category: "Income & Percentages",
    inputs: [],
    formatOutput: (v) => fmt.percent(v),
  },
  {
    name: "lpReward",
    title: "LP Reward",
    description: "Read `lpReward` from the contract",
    icon: "💰",
    category: "Linked Contracts",
    inputs: [],
  },
  {
    name: "nemiToken",
    title: "NEMI Token",
    description: "Read `nemiToken` from the contract",
    icon: "🪙",
    category: "Basic Info",
    inputs: [],
  },
  {
    name: "nftMarketPlace",
    title: "NFT Market Place",
    description: "Read `nftMarketPlace` from the contract",
    icon: "🛒",
    category: "Linked Contracts",
    inputs: [],
  },
  {
    name: "nftReward",
    title: "NFT Reward",
    description: "Read `nftReward` from the contract",
    icon: "💰",
    category: "Linked Contracts",
    inputs: [],
  },
  {
    name: "owner",
    title: "Owner",
    description: "Read `owner` from the contract",
    icon: "👑",
    category: "Basic Info",
    inputs: [],
  },
  {
    name: "pair",
    title: "Pair",
    description: "Read `pair` from the contract",
    icon: "🔁",
    category: "Basic Info",
    inputs: [],
  },
  {
    name: "paused",
    title: "Paused",
    description: "Read `paused` from the contract",
    icon: "⏸️",
    category: "Basic Info",
    inputs: [],
    formatOutput: (v) => fmt.bool(v),
  },
  {
    name: "planInfo",
    title: "Plan Info",
    description: "Price, limit, holding requirement and direct count of a level.",
    icon: "🏆",
    category: "Plans & Levels",
    inputs: [
      { name: "arg0", type: "uint8", label: "Index", placeholder: "Enter value", required: true },
    ],
    formatOutput: (v) => [
      `Plan Price: ${fmt.amount(v.planPrice ?? v[0])}`,
      `Plan Limit: ${fmt.amount(v.planLimit ?? v[1])}`,
      `Holding NFT: ${v.holdingNft ?? v[2]}`,
      `Direct Count: ${v.directCount ?? v[3]}`,
    ].join("\n"),
  },
  {
    name: "platformIncomePercent",
    title: "Platform Income Percent",
    description: "Read `platformIncomePercent` from the contract",
    icon: "💰",
    category: "Income & Percentages",
    inputs: [],
    formatOutput: (v) => fmt.percent(v),
  },
  {
    name: "platformIncomeReceiver1",
    title: "Platform Income Receiver1",
    description: "Read `platformIncomeReceiver1` from the contract",
    icon: "💰",
    category: "Receivers & Wallets",
    inputs: [],
  },
  {
    name: "platformIncomeReceiver2",
    title: "Platform Income Receiver2",
    description: "Read `platformIncomeReceiver2` from the contract",
    icon: "💰",
    category: "Receivers & Wallets",
    inputs: [],
  },
  {
    name: "platformIncomeReceiver3",
    title: "Platform Income Receiver3",
    description: "Read `platformIncomeReceiver3` from the contract",
    icon: "💰",
    category: "Receivers & Wallets",
    inputs: [],
  },
  {
    name: "router",
    title: "Router",
    description: "Read `router` from the contract",
    icon: "🔁",
    category: "Basic Info",
    inputs: [],
  },
  {
    name: "saleNftDirectThresholds",
    title: "Sale NFT Direct Thresholds",
    description: "Direct-count threshold for a sale level (a count).",
    icon: "💲",
    category: "Trading",
    inputs: [
      { name: "arg0", type: "uint256", label: "Index", placeholder: "Enter value", required: true },
    ],
  },
  {
    name: "saleNftLevelPercents",
    title: "Sale NFT Level Percents",
    description: "Raw level percent value as stored by the contract.",
    icon: "📊",
    category: "Income & Percentages",
    inputs: [
      { name: "arg0", type: "uint256", label: "Index", placeholder: "Enter value", required: true },
    ],
  },
  {
    name: "stakingReward",
    title: "Staking Reward",
    description: "Read `stakingReward` from the contract",
    icon: "🔒",
    category: "Linked Contracts",
    inputs: [],
  },
  {
    name: "topWallet",
    title: "Top Wallet",
    description: "Read `topWallet` from the contract",
    icon: "🥇",
    category: "Receivers & Wallets",
    inputs: [],
  },
  {
    name: "totalLevel",
    title: "Total Level",
    description: "Read `totalLevel` from the contract",
    icon: "📈",
    category: "Plans & Levels",
    inputs: [],
  },
  {
    name: "totalUsers",
    title: "Total Users",
    description: "Read `totalUsers` from the contract",
    icon: "👤",
    category: "Other",
    inputs: [],
  },
  {
    name: "usdtToken",
    title: "USDT Token",
    description: "Read `usdtToken` from the contract",
    icon: "🪙",
    category: "Basic Info",
    inputs: [],
  },
  {
    name: "userHoldInfo",
    title: "User Hold Info",
    description: "Read `userHoldInfo` from the contract",
    icon: "👤",
    category: "User Info",
    inputs: [
      { name: "arg0", type: "address", label: "Address", placeholder: "0x…", required: true },
    ],
    formatOutput: (v) => [
      `User Total Limit: ${fmt.amount(v.userTotalLimit ?? v[0])}`,
      `Total Reward Earned: ${fmt.amount(v.totalRewardEarned ?? v[1])}`,
      `User Last Draw: ${fmt.time(v.userLastDraw ?? v[2])}`,
      `User Last Cycle: ${v.userLastCycle ?? v[3]}`,
      `Is Exclude Condition: ${fmt.bool(v.isExcludeCondition ?? v[4])}`,
      `Is Blocked: ${fmt.bool(v.isBlocked ?? v[5])}`,
      `Is Resync: ${fmt.bool(v.isResync ?? v[6])}`,
      `Principle Burn Collected: ${v.principleBurnCollected ?? v[7]}`,
    ].join("\n"),
  },
  {
    name: "userHoldingLevelAmount",
    title: "User Holding Level Amount",
    description: "Read `userHoldingLevelAmount` from the contract",
    icon: "💲",
    category: "User Info",
    inputs: [
      { name: "arg0", type: "address", label: "Address", placeholder: "0x…", required: true },
      { name: "arg1", type: "uint256", label: "Index", placeholder: "Enter value", required: true },
    ],
    formatOutput: (v) => fmt.amount(v),
  },
  {
    name: "userHoldingStatus",
    title: "User Holding Status",
    description: "Read `userHoldingStatus` from the contract",
    icon: "👤",
    category: "User Info",
    inputs: [
      { name: "arg0", type: "address", label: "Address", placeholder: "0x…", required: true },
      { name: "arg1", type: "uint256", label: "Index", placeholder: "Enter value", required: true },
    ],
    formatOutput: (v) => fmt.bool(v),
  },
  {
    name: "userInfo",
    title: "User Info",
    description: "Full matrix profile of an account.",
    icon: "👤",
    category: "User Info",
    inputs: [
      { name: "arg0", type: "address", label: "Address", placeholder: "0x…", required: true },
    ],
    formatOutput: (v) => [
      `Current Level: ${v.currentLevel ?? v[0]}`,
      `ID: ${v.id ?? v[1]}`,
      `Direct Count: ${v.directCount ?? v[2]}`,
      `Reward Earned: ${fmt.amount(v.rewardEarned ?? v[3])}`,
      `Last Time Stamp: ${fmt.time(v.lastTimeStamp ?? v[4])}`,
      `Direct Referrer: ${v.directReferrer ?? v[5]}`,
      `First Upline: ${v.firstUpline ?? v[6]}`,
      `Is Downline Reached: ${fmt.bool(v.isDownlineReached ?? v[7])}`,
    ].join("\n"),
  },
  {
    name: "userLevelHoldRequire",
    title: "User Level Hold Require",
    description: "Holdings required to unlock a level (a count).",
    icon: "👤",
    category: "User Info",
    inputs: [],
  },
];

export const writeFunctions = [
  {
    name: "payAdvance",
    title: "Pay Advance",
    description: "Pay the advance fee to get an exemption for the configured period.",
    icon: "💳",
    category: "User Actions",
    inputs: [],
    payment: [
      { token: "USDT", amount: ({ contract }) => contract.methods.advancePaymentAmount().call() },
    ],
  },
  {
    name: "subscribe",
    title: "Subscribe / Upgrade",
    description: "Join the matrix under a referrer, or upgrade to a higher level.",
    icon: "🚀",
    category: "User Actions",
    inputs: [
      { name: "referrer", type: "address", label: "Referrer", placeholder: "0x…", required: true, hint: "Your upline. Use the top wallet if you have no sponsor." },
      { name: "level", type: "uint8", label: "Level", placeholder: "1 – totalLevel", required: true, hint: "Check Plan Info for the price of each level." },
    ],
    payment: [
      {
        token: "USDT",
        amount: async ({ contract, args }) => (await contract.methods.planInfo(args[1]).call()).planPrice,
      },
    ],
  },
];

export const adminFunctions = [
  {
    name: "addNewPakage",
    title: "Add New Package",
    description: "Call `addNewPakage` on the contract",
    icon: "🏆",
    category: "Admin Operations",
    ownerOnly: true,
    inputs: [
      { name: "index", type: "uint8", label: "Index", placeholder: "Enter index", required: true },
      { name: "newPlan", type: "tuple", label: "New Plan", placeholder: "planPrice, planLimit, holdingNft, directCount", required: true, isTuple: true, components: [{name: "planPrice",type: "uint256",unit: "ether"},{name: "planLimit",type: "uint256"},{name: "holdingNft",type: "uint256"},{name: "directCount",type: "uint256"}] },
      { name: "newTotalLevel", type: "uint8", label: "New Total Level", placeholder: "Enter new total level", required: true },
    ],
  },
  {
    name: "botSubScribe",
    title: "Bot Sub Scribe",
    description: "Call `botSubScribe` on the contract",
    icon: "🚀",
    category: "Admin Operations",
    ownerOnly: true,
    inputs: [
      { name: "userAccount", type: "address", label: "User Account", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "initialize",
    title: "Initialize",
    description: "Call `initialize` on the contract",
    icon: "⚙️",
    category: "Admin Control",
    ownerOnly: true,
    inputs: [
      { name: "initialOwner", type: "address", label: "Initial Owner", placeholder: "0x…", required: true },
      { name: "nftMarketPlaceContract", type: "address", label: "NFT Market Place Contract", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "newSetup",
    title: "New Setup",
    description: "Call `newSetup` on the contract",
    icon: "⚙️",
    category: "Admin Control",
    ownerOnly: true,
    inputs: [],
  },
  {
    name: "nftSaleDistribute",
    title: "NFT Sale Distribute",
    description: "Call `nftSaleDistribute` on the contract",
    icon: "🛒",
    category: "Admin Operations",
    inputs: [
      { name: "tradeId", type: "uint256", label: "Trade ID", placeholder: "Enter trade id", required: true },
      { name: "currentDirect", type: "address", label: "Current Direct", placeholder: "0x…", required: true },
      { name: "amount", type: "uint256", label: "Amount", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "pause",
    title: "Pause",
    description: "Call `pause` on the contract",
    icon: "⏸️",
    category: "Admin Control",
    ownerOnly: true,
    inputs: [],
  },
  {
    name: "recordPrincipleBurn",
    title: "Record Principle Burn",
    description: "Call `recordPrincipleBurn` on the contract",
    icon: "🔥",
    category: "Admin Operations",
    inputs: [
      { name: "account", type: "address", label: "Account", placeholder: "0x…", required: true },
      { name: "amount", type: "uint256", label: "Amount", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "recoverErc20",
    title: "Recover ERC20",
    description: "Call `recoverErc20` on the contract",
    icon: "♻️",
    category: "Admin Recovery",
    ownerOnly: true,
    inputs: [
      { name: "erc20Token", type: "address", label: "ERC20 Token", placeholder: "0x…", required: true },
      { name: "amount", type: "uint256", label: "Amount", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "recoverEth",
    title: "Recover ETH",
    description: "Call `recoverEth` on the contract",
    icon: "♻️",
    category: "Admin Recovery",
    ownerOnly: true,
    inputs: [
      { name: "amount", type: "uint256", label: "Amount", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "renounceOwnership",
    title: "Renounce Ownership",
    description: "Call `renounceOwnership` on the contract",
    icon: "👑",
    category: "Admin Control",
    ownerOnly: true,
    inputs: [],
  },
  {
    name: "resyncOwner",
    title: "Resync Owner",
    description: "Call `resyncOwner` on the contract",
    icon: "👑",
    category: "Admin Operations",
    ownerOnly: true,
    inputs: [
      { name: "startIndex", type: "uint256", label: "Start Index", placeholder: "Enter start index", required: true },
      { name: "endIndex", type: "uint256", label: "End Index", placeholder: "Enter end index", required: true },
    ],
  },
  {
    name: "setAdvancePaymentConfig",
    title: "Set Advance Payment Config",
    description: "Call `setAdvancePaymentConfig` on the contract",
    icon: "💳",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newAdvancePaymentAmount", type: "uint256", label: "New Advance Payment Amount", placeholder: "e.g. 10.5", required: true, unit: "ether" },
      { name: "newAdvanceExemptionPeriod", type: "uint256", label: "New Advance Exemption Period", placeholder: "Enter new advance exemption period", required: true },
    ],
  },
  {
    name: "setBotStatus",
    title: "Set Bot Status",
    description: "Call `setBotStatus` on the contract",
    icon: "🤖",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "account", type: "address", label: "Account", placeholder: "0x…", required: true },
      { name: "status", type: "bool", label: "Status", placeholder: "true / false", required: true },
    ],
  },
  {
    name: "setGlobalNftLimitPeriod",
    title: "Set Global NFT Limit Period",
    description: "Call `setGlobalNftLimitPeriod` on the contract",
    icon: "⏱️",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newGlobalNftLimitPeriod", type: "uint256", label: "New Global NFT Limit Period", placeholder: "Enter new global nft limit period", required: true },
    ],
  },
  {
    name: "setHoldingMax",
    title: "Set Holding Max",
    description: "Call `setHoldingMax` on the contract",
    icon: "📈",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newHoldingMax", type: "uint256", label: "New Holding Max", placeholder: "Enter new holding max", required: true },
    ],
  },
  {
    name: "setIncomePercent",
    title: "Set Income Percent",
    description: "Call `setIncomePercent` on the contract",
    icon: "💰",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newDirectOne", type: "uint256", label: "New Direct One", placeholder: "Enter new direct one", required: true },
      { name: "newCurrLevel", type: "uint256", label: "New Curr Level", placeholder: "Enter new curr level", required: true },
      { name: "newPlatform", type: "uint256", label: "New Platform", placeholder: "Enter new platform", required: true },
      { name: "newBurnIncomePercent", type: "uint256", label: "New Burn Income Percent", placeholder: "Enter new burn income percent", required: true },
      { name: "newBuyingIncomePercent", type: "uint256", label: "New Buying Income Percent", placeholder: "Enter new buying income percent", required: true },
    ],
  },
  {
    name: "setLpRewardContract",
    title: "Set LP Reward Contract",
    description: "Call `setLpRewardContract` on the contract",
    icon: "💰",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newLpReward", type: "address", label: "New LP Reward", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "setNemiToken",
    title: "Set NEMI Token",
    description: "Call `setNemiToken` on the contract",
    icon: "🪙",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newNemiToken", type: "address", label: "New NEMI Token", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "setNewNftMarketPlace",
    title: "Set New NFT Market Place",
    description: "Call `setNewNftMarketPlace` on the contract",
    icon: "🛒",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newNftMarketPlace", type: "address", label: "New NFT Market Place", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "setNewnHoldingNft",
    title: "Set Newn Holding NFT",
    description: "Call `setNewnHoldingNft` on the contract",
    icon: "⚙️",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newHoldingNft", type: "uint8[8]", label: "New Holding NFT", placeholder: "Enter new holding nft", required: true, isFixedArray: true, arraySize: 8 },
    ],
  },
  {
    name: "setNftLevelStatus",
    title: "Set NFT Level Status",
    description: "Call `setNftLevelStatus` on the contract",
    icon: "🏆",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "userAccount", type: "address", label: "User Account", placeholder: "0x…", required: true },
      { name: "nftPrice", type: "uint256", label: "NFT Price", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "setNftRewardContract",
    title: "Set NFT Reward Contract",
    description: "Call `setNftRewardContract` on the contract",
    icon: "💰",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newNftReward", type: "address", label: "New NFT Reward", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "setPlatformIncomeReceivers",
    title: "Set Platform Income Receivers",
    description: "Call `setPlatformIncomeReceivers` on the contract",
    icon: "💰",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newPlatformIncomeReceiver1", type: "address", label: "New Platform Income Receiver1", placeholder: "0x…", required: true },
      { name: "newPlatformIncomeReceiver2", type: "address", label: "New Platform Income Receiver2", placeholder: "0x…", required: true },
      { name: "newPlatformIncomeReceiver3", type: "address", label: "New Platform Income Receiver3", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "setPrincipleReceivers",
    title: "Set Principle Receivers",
    description: "Call `setPrincipleReceivers` on the contract",
    icon: "⚙️",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newCreatorReceiver", type: "address", label: "New Creator Receiver", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "setRewardAmount",
    title: "Set Reward Amount",
    description: "Call `setRewardAmount` on the contract",
    icon: "💰",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "account", type: "address", label: "Account", placeholder: "0x…", required: true },
      { name: "amount", type: "uint256", label: "Amount", placeholder: "e.g. 10.5", required: true, unit: "ether" },
    ],
  },
  {
    name: "setRouterAndPair",
    title: "Set Router And Pair",
    description: "Call `setRouterAndPair` on the contract",
    icon: "🔁",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newRouter", type: "address", label: "New Router", placeholder: "0x…", required: true },
      { name: "newPair", type: "address", label: "New Pair", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "setStakingRewardContract",
    title: "Set Staking Reward Contract",
    description: "Call `setStakingRewardContract` on the contract",
    icon: "🔒",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newStakingReward", type: "address", label: "New Staking Reward", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "setTokenApproveMax",
    title: "Set Token Approve Max",
    description: "Call `setTokenApproveMax` on the contract",
    icon: "🪙",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [],
  },
  {
    name: "setUpgradeCondition",
    title: "Set Upgrade Condition",
    description: "Call `setUpgradeCondition` on the contract",
    icon: "⚙️",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newDirectCond", type: "uint256[8]", label: "New Direct Cond", placeholder: "Enter new direct cond", required: true, isFixedArray: true, arraySize: 8 },
    ],
  },
  {
    name: "setUsdtToken",
    title: "Set USDT Token",
    description: "Call `setUsdtToken` on the contract",
    icon: "🪙",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newToken", type: "address", label: "New Token", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "setUserBlockRewardCondition",
    title: "Set User Block Reward Condition",
    description: "Call `setUserBlockRewardCondition` on the contract",
    icon: "🚫",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "userAccount", type: "address", label: "User Account", placeholder: "0x…", required: true },
      { name: "status", type: "bool", label: "Status", placeholder: "true / false", required: true },
    ],
  },
  {
    name: "setUserExcludeRewardCondition",
    title: "Set User Exclude Reward Condition",
    description: "Call `setUserExcludeRewardCondition` on the contract",
    icon: "🚫",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "userAccount", type: "address", label: "User Account", placeholder: "0x…", required: true },
      { name: "status", type: "bool", label: "Status", placeholder: "true / false", required: true },
    ],
  },
  {
    name: "setUserLevelHoldRequire",
    title: "Set User Level Hold Require",
    description: "Call `setUserLevelHoldRequire` on the contract",
    icon: "👤",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newUserLevelHoldRequire", type: "uint256", label: "New User Level Hold Require", placeholder: "Enter new user level hold require", required: true },
    ],
  },
  {
    name: "setnewSaleNftDirectThresholds",
    title: "Setnew Sale NFT Direct Thresholds",
    description: "Call `setnewSaleNftDirectThresholds` on the contract",
    icon: "💲",
    category: "Admin Settings",
    ownerOnly: true,
    inputs: [
      { name: "newThresholds", type: "uint8[10]", label: "New Thresholds", placeholder: "Enter new thresholds", required: true, isFixedArray: true, arraySize: 10 },
    ],
  },
  {
    name: "subscribeOwner",
    title: "Subscribe Owner",
    description: "Call `subscribeOwner` on the contract",
    icon: "🚀",
    category: "Admin Operations",
    ownerOnly: true,
    inputs: [
      { name: "userAccount", type: "address[]", label: "User Account", placeholder: "value1, value2, …", required: true, isArray: true },
      { name: "referrer", type: "address[]", label: "Referrer", placeholder: "value1, value2, …", required: true, isArray: true },
      { name: "level", type: "uint8", label: "Level", placeholder: "Enter level", required: true },
      { name: "isBlockBool", type: "bool", label: "Is Block Bool", placeholder: "true / false", required: true },
    ],
  },
  {
    name: "transferOwnership",
    title: "Transfer Ownership",
    description: "Call `transferOwnership` on the contract",
    icon: "👑",
    category: "Admin Control",
    ownerOnly: true,
    inputs: [
      { name: "newOwner", type: "address", label: "New Owner", placeholder: "0x…", required: true },
    ],
  },
  {
    name: "unpause",
    title: "Unpause",
    description: "Call `unpause` on the contract",
    icon: "▶️",
    category: "Admin Control",
    ownerOnly: true,
    allowWhilePaused: true,
    inputs: [],
  },
];

const matrixFunctions = { readFunctions, writeFunctions, adminFunctions };
export default matrixFunctions;
